const UnauthorizedMessageStatusTypes = {
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    INVALID_TOKEN_SENT_NEW_EMAIL: "INVALID_TOKEN_SENT_NEW_EMAIL",
    INVALID_TOKEN: "INVALID_TOKEN"
} as const;
export type UnauthorizedMessageStatusTypes = keyof typeof UnauthorizedMessageStatusTypes;

export const UnauthorizedException = (messageCode: UnauthorizedMessageStatusTypes | string, message: string) => ({
    error: new Error(message),
    status: messageCode,
    code: 401
})